// src/data/api/helios-service/locationService.ts

import { apiHeliosClient } from 'src/data/api/apiHeliosClient';
import {
  CreateLocationCommand,
  CreateLocationCommandInput,
  GetLocationCommand,
  GetLocationCommandInput,
  ListLocationsCommand,
  ListLocationsCommandInput,
  UpdateLocationCommand,
  UpdateLocationCommandInput,
} from '@amzn/gbsa-helios-typescript-client';

export const locationService = {
  // Get all locations
  getAll: (data: ListLocationsCommandInput) => {
    return apiHeliosClient.send(new ListLocationsCommand(data));
  },

  // Create location
  createLocation: (data: CreateLocationCommandInput) => {
    return apiHeliosClient.send(new CreateLocationCommand(data));
  },

  // Update location
  updateLocation: (data: UpdateLocationCommandInput) => {
    return apiHeliosClient.send(new UpdateLocationCommand(data));
  },
  // Get location
  getLocation: (data: GetLocationCommandInput) => {
    return apiHeliosClient.send(new GetLocationCommand(data));
  },
};
